import { Tooltip } from 'bootstrap';

export default {
  mounted(el) {
    // Force the tooltip to append to the body to ensure standard Bootstrap styling
    applyTooltip(el);
  },

  updated(el) {
    const instance = Tooltip.getInstance(el);
    if (instance) {
      // Pulls the newly updated reactive :title attribute string value dynamically
      const currentTitle = el.getAttribute('title');
      el.removeAttribute('title');
      el.setAttribute('data-bs-title', currentTitle);
      if (currentTitle) {
        instance.setContent({ '.tooltip-inner': currentTitle });
      }
    }
  },

  unmounted(el) {
    const tooltip = Tooltip.getInstance(el);
    if (tooltip) {
      tooltip.dispose();
    }
  }
};

export function applyTooltip(el) {
    const title = el.getAttribute('title') || el.getAttribute('data-bs-title');
    if (!title) return;
    const placement = el.getAttribute('data-bs-placement') || 'top';
    el.removeAttribute('title');
    el.setAttribute('data-bs-title', title);
    el.setAttribute('data-bs-toggle', 'tooltip');
    el.setAttribute('data-bs-placement', placement);
    // Clear old to avoid memory leak before creating new
    const tooltip = Tooltip.getInstance(el);
    if (tooltip) tooltip.dispose();
    new Tooltip(el, {
      container: 'body',
      trigger: 'hover',
      placement: placement,
      boundary: 'clippingParents',
    });
}
